import fetch from "isomorphic-fetch";
import { devAPI } from "../util/urls";
export const getGlobalMaterials = async () => {
  try {
    const res = await fetch(`${devAPI}/organizations/-1`);
    const parsed = await res.json();

    return parsed.globalMaterials;
  } catch (e) {
    console.error(e);
    return null;
  }
};
